<template>
  <v-widget
    :title="$t('Password Settings')"
    class="mb-4"
  >
    <div slot="widget-content">
      <v-text-field
        v-model="user.password"
        :error-count="user.displayErrors('password').length"
        :error-messages="user.displayErrors('password')"
        :label="$t('New password')"
        outline
        type="password"
      />

      <v-text-field
        v-model="user.password_confirmation"
        :error-count="user.displayErrors('password_confirmation').length"
        :error-messages="user.displayErrors('password_confirmation')"
        :label="$t('New password confirmation')"
        outline
        type="password"
      />
    </div>
  </v-widget>
</template>

<script>

export default {
  name: 'UserPassword',

  props: {
    user: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      menu: false
    }
  }
}
</script>
